import { NgModule } from "@angular/core";
import { SharedModule } from "@app/shared";

import {
  LanguageService,
  LocalStorageService,
  RegionService,
  MobileAppService,
  TokenStorageService,
} from "./services";
import { WASAuthService } from "./services/was-auth.service";

import { CoreRoutingModule } from "./core-routing.module";
import { AppState, AppStateStore, AppStateQuery } from "./state/app";
import { AlertState, AlertStore, AlertQuery } from "./state/alert";
import { UserState, UserStore, UserQuery } from "./state/user";
import { RouterState } from "./state/router";
import {
  UserFacade,
  UserStateBase,
  AlertFacade,
  AppFacade,
  AppStateBase,
  AlertStateBase,
  AuthService,
} from "./app-services";
import { UserApiClient, NgrpApiClient } from "./data-services";
import { AuthEffect } from "./state-effects";
import {
  AppComponent,
  AppMainComponent,
  AppShellComponent,
  NavbarComponent,
  AlertsContainerComponent,
  AlertComponent,
  GlobalErrorComponent,
  GlobalErrorContainerComponent,
  MobileAppModalProvider,
  MobileAppModalContainerComponent,
  MobileAppModalComponent,
  MastercardLandingPageComponent,
  AuthCallbackComponent,
} from "./ui-components";

@NgModule({
  imports: [SharedModule, CoreRoutingModule],
  declarations: [
    AppComponent,
    AppShellComponent,
    NavbarComponent,
    AlertsContainerComponent,
    AlertComponent,
    GlobalErrorComponent,
    GlobalErrorContainerComponent,
    MobileAppModalContainerComponent,
    MobileAppModalComponent,
    AppMainComponent,
    MastercardLandingPageComponent,
    AuthCallbackComponent,
  ],
  providers: [
    AuthService,
    LanguageService,
    LocalStorageService,
    RegionService,
    MobileAppService,
    MobileAppModalProvider,
    TokenStorageService,
    WASAuthService,
    RouterState,

    AppFacade,
    AppStateStore,
    AppStateQuery,
    { provide: AppStateBase, useClass: AppState },

    AlertFacade,
    AlertStore,
    AlertQuery,
    { provide: AlertStateBase, useClass: AlertState },

    UserFacade,
    UserStore,
    UserQuery,
    { provide: UserStateBase, useClass: UserState },

    UserApiClient,
    NgrpApiClient,
    AuthEffect,
  ],
  entryComponents: [MobileAppModalContainerComponent],
})
export class CoreModule {}
